import type { IModuleUspBanner } from "@contentful-api/types/contentful";
import { useAuth } from "@lib/auth/useAuth";
import { removeEmptyContent } from "@lib/utils/cleanContent";
import { saleSeasonGradient } from "ui/src/design-tokens/01.colors/colors";
import { getAnimatedContainerStyle } from "../USPbanner.styles";

interface UseUSPBannerConfigProps {
    uspBanner: IModuleUspBanner;
    backgroundColor?: string;
}

export const useUSPBannerConfig = ({ uspBanner, backgroundColor }: UseUSPBannerConfigProps) => {
    const { isAuthenticated } = useAuth();

    const isSaleSeason = uspBanner?.fields?.isSaleSeason ?? false;

    // Show sale season colors only when it's sale season AND user is not authenticated
    const shouldShowSaleColors = isSaleSeason && !isAuthenticated;
    const bannerBackground = shouldShowSaleColors
        ? saleSeasonGradient
        : backgroundColor || "gray.100";
    const animatedContainerStyle = getAnimatedContainerStyle(shouldShowSaleColors);

    const uspMessages = Object.values(uspBanner?.fields || {})
        .filter(Boolean)
        .filter((item) => item.content && Array.isArray(item.content))
        .map((item) => removeEmptyContent(item))
        .filter((item) => item.content?.length > 0);

    return {
        bannerBackground,
        animatedContainerStyle,
        uspMessages,
        isSaleSeason: shouldShowSaleColors,
    };
};
